import React, { memo, useState } from 'react';
import { connect } from 'react-redux';
import styles from './styles.module.css';
import { Button, Input } from '../../../../../common/ui';
import { createSupplier } from '../../actions';
import { useNavigate } from 'react-router-dom';
import { showAlert } from '../../../../../common/actions';
import PropTypes from 'prop-types';

const AddNewSupplier = memo(({ createSupplier, showAlert }) => {
  const [isLoading, setLoading] = useState(false);
  const [companyNameError, setCompanyNameError] = useState('');
  const [supplierForm, setSupplierForm] = useState({
    companyname: '',
    address: '',
    contact_no: '',
  });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const companyname = (supplierForm.companyname ?? '').trim();
    if (!companyname) {
      setCompanyNameError('Please enter the company name.');
      return;
    }
    setCompanyNameError('');
    setLoading(true);
    const isSuccess = await createSupplier({ ...supplierForm, companyname });
    setLoading(false);
    if (isSuccess) {
      showAlert({
        isAlertOpen: true,
        alertType: 'success',
        alertMessage: 'Supplier created successfully.',
      });
      navigate('/inventory/suppliers');
    } else {
      showAlert({
        isAlertOpen: true,
        alertType: 'danger',
        alertMessage: 'Operation failed. Please try again later.',
      });
    }
  };

  const handleCancel = () => {
    navigate('/inventory/suppliers');
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.pageTitle}>New Supplier</h1>
      </header>
      <div className={styles.body}>
        <form onSubmit={handleSubmit} noValidate className={styles.formCard}>
          <div className={styles.formSection}>
            <div className={styles.fieldGroup}>
              <Input
                label="Company Name"
                type="text"
                value={supplierForm.companyname}
                onChange={(value) => {
                  setSupplierForm((prev) => ({ ...prev, companyname: value }));
                  if (companyNameError) setCompanyNameError('');
                }}
                placeholder="Company name"
                error={companyNameError}
              />
            </div>
            <div className={styles.fieldGroup}>
              <Input
                label="Address"
                type="text"
                value={supplierForm.address}
                onChange={(value) =>
                  setSupplierForm((prev) => ({ ...prev, address: value }))
                }
                placeholder="Address"
              />
            </div>
            <div className={styles.fieldGroup}>
              <Input
                label="Contact No"
                type="text"
                value={supplierForm.contact_no}
                onChange={(value) =>
                  setSupplierForm((prev) => ({ ...prev, contact_no: value }))
                }
                placeholder="Contact number"
              />
            </div>
          </div>
          <div className={styles.buttonPanel}>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Submit'}
            </Button>
            <Button type="button" variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
});

AddNewSupplier.propTypes = {
  createSupplier: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  suppliersState: state.suppliersState,
});

export default connect(mapStateToProps, {
  createSupplier,
  showAlert,
})(AddNewSupplier);
